import { Button } from '@strata/react-buttons';
import { WarningDialog } from '@strata/react-dialog';
import { DetailValue } from '@strata/react-label-value-pairs';
import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';

import {
    getPatientRelationshipDisplayText,
    isSamePatientPreference,
    PatientRelationshipType,
    PatientRelationshipTypeDisplayNameMap,
} from 'services/RouteRuleHelpers';

export const DeletePatientRelationshipDialog = ({ patientRelationshipType }) => {
    const formik = useFormikContext();
    return (
        <WarningDialog
            dialogTitle="Confirm Delete"
            width={600}
            isOpen={!!formik.values.relationshipToDelete}
            primaryButtonIntent={Button.Intent.DANGER}
            primaryButtonLabel="Yes, Delete"
            secondaryButtonLabel="No, Cancel"
            onPrimaryButtonClick={() =>
                formik.setValues({
                    ...formik.values,
                    patientRelationships: formik.values.patientRelationships.filter(
                        (rel) => !isSamePatientPreference(rel, formik.values.relationshipToDelete),
                    ),
                    relationshipToDelete: undefined,
                })
            }
            onSecondaryButtonClick={() => formik.setFieldValue('relationshipToDelete', undefined)}
            dialogContent={
                <>
                    <p className="margin__bottom--large">
                        {`Are you sure you want to delete the following ${PatientRelationshipTypeDisplayNameMap[patientRelationshipType]}?`}
                    </p>
                    <div className="margin__bottom--small">
                        <DetailValue
                            value={getPatientRelationshipDisplayText(
                                formik.values.relationshipToDelete,
                            )}
                        />
                    </div>
                </>
            }
        />
    );
};

DeletePatientRelationshipDialog.propTypes = {
    patientRelationshipType: PropTypes.oneOf(Object.values(PatientRelationshipType)).isRequired,
};
